module.exports = __webpack_public_path__ + "static/media/donbosco1.b6dde99b.jpg";